module.exports = __webpack_public_path__ + "img/express-delivery.fa26fb16.svg";